import * as React from 'react';
import { Provider } from 'react-redux';
import './App.css';
import appStore from './store/store';
import PrimaryNavContainer from './component/nav/topNav/PrimaryNavContainer';
import MainContainer from './component/main/MainContainer';
import SecondaryNavContainer from './component/nav/bottomNav/SecondaryNavContainer';

const store = appStore();

class App extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <div className="app-wrapper">
                    <PrimaryNavContainer />
                    <main className="main-wrapper">
                        <MainContainer />
                        <SecondaryNavContainer />
                    </main>
                </div>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx